<template>
  <div id="contractResume">
    <div class="row  mx-1">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Datos de la Promoción</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Nombre</div>
            <p>{{promotionData.name || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Descripción</div>
            <p>{{promotionData.description || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Condiciones legales</div>
            <p>{{promotionData.legal_conditions || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Fecha inicio</div>
            <p>{{promotionData.start_date || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Fecha fin</div>
            <p>{{promotionData.end_date || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Tenant</div>
            <p>{{promotionData.tenant.join(", ") || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Canal</div>
            <p>{{promotionData.channel.join(", ") || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Limite de unidades</div>
            <p>{{promotionData.units_limit || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Acumulable por contrato</div>
            <p v-if="promotionData.cumulative">Si</p>
            <p v-else>No</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Acumulable por cliente</div>
            <p v-if="promotionData.cumulativeCustumer">Si</p>
            <p v-else>No</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Prioridad</div>
            <p>{{promotionData.priority|| "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Aplicar sobre BI+IVA</div>
            <p v-if="promotionData.applyToRentServ">Si</p>
            <p v-else>No</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row  mx-1">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Tipo de Promoción</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Estilo de Promoción</div>
            <p>{{extraPromoData.promoType || "-"}}</p>
          </div>
        <template v-if="extraPromoData.promoType == 'PRODUCTO'">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Marca</div>
            <p>{{extraPromoData.brand || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2" v-if="extraPromoData.model">
            <div class="generalTitleItemModal">Modelo</div>
            <p>{{extraPromoData.model || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2" v-if="extraPromoData.capacity">
            <div class="generalTitleItemModal">Capacidad</div>
            <p>{{extraPromoData.capacity || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2" v-if="extraPromoData.color">
            <div class="generalTitleItemModal">Color</div>
            <p>{{extraPromoData.color || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Referencias en la promoción</div>
            <span>{{promotionData.products.length || "-"}}</span>
            -
            <span @click="viewDetail" class="textLink"> Ver detalle</span>
          </div>
        </template>
        <template v-else-if="extraPromoData.promoType == 'VOUCHER'">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Cupón promocional</div>
            <p>{{promotionData.vouchers.voucher_code || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Límite de uso</div>
            <p>{{promotionData.vouchers.use_limit || "-"}}</p>
          </div>
          <div v-if="Array.isArray(promotionData.customers.legal_identifier) && promotionData.customers.legal_identifier.length >0" class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Clientes</div>
            <template v-for="(data, index) in promotionData.customers.legal_identifier">
              {{ data }}{{ index === (promotionData.customers.legal_identifier.length - 1) ? '' : ', ' }}
            </template>
          </div>
        </template>
        <template v-else-if="extraPromoData.promoType == 'CLIENTE'">
          <div v-if="Array.isArray(promotionData.customers.legal_identifier) && promotionData.customers.legal_identifier.length >0" class="col-6 col-sm-6 col-lg-6">
            <div class="generalTitleItemModal">Clientes</div>
            <template v-for="(data, index) in promotionData.customers.legal_identifier">
              {{ data }}{{ index === (promotionData.customers.legal_identifier.length - 1) ? '' : ', ' }}
            </template>
          </div>
        </template>
        <!-- <template v-else-if="extraPromoData.promoType == 'Cliente'">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Cupon promocional</div>
            <p>{{promotionData.voucher.voucher_code || "-"}}</p>
          </div>
        </template> -->
        </div>
      </div>
    </div>
    <div class="row  mx-1">
      <div class="col-12">
        <div class="mb-3">
          <div class="generalSubtitle">Tipo de Promoción</div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Tipo de descuento</div>
            <p>{{extraPromoData.discountTypeName || "-"}}</p>
          </div>
          <div class="col-6 col-sm-4 col-lg-2">
            <div class="generalTitleItemModal">Tipo de ejecución</div>
            <p>{{extraPromoData.executionType || "-"}}</p>
          </div>
          <template v-if="extraPromoData.executionType == 'Todos'">
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cantidad</div>
              <p>{{extraPromoData.feeTotalNumber || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
          </template>
        </div>
        <template v-if="extraPromoData.executionType == 'Selección'">
          <div class="row mt-3">
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 1</div>
              <p>{{promotionData.feeDiscounts[0].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 2</div>
              <p>{{promotionData.feeDiscounts[1].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 3</div>
              <p>{{promotionData.feeDiscounts[2].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 4</div>
              <p>{{promotionData.feeDiscounts[3].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 5</div>
              <p>{{promotionData.feeDiscounts[4].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 6</div>
              <p>{{promotionData.feeDiscounts[5].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 7</div>
              <p>{{promotionData.feeDiscounts[6].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 8</div>
              <p>{{promotionData.feeDiscounts[7].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 9</div>
              <p>{{promotionData.feeDiscounts[8].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 10</div>
              <p>{{promotionData.feeDiscounts[9].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 11</div>
              <p>{{promotionData.feeDiscounts[10].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 12</div>
              <p>{{promotionData.feeDiscounts[11].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 13</div>
              <p>{{promotionData.feeDiscounts[12].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 14</div>
              <p>{{promotionData.feeDiscounts[13].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 15</div>
              <p>{{promotionData.feeDiscounts[14].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 16</div>
              <p>{{promotionData.feeDiscounts[15].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 17</div>
              <p>{{promotionData.feeDiscounts[16].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 18</div>
              <p>{{promotionData.feeDiscounts[17].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 19</div>
              <p>{{promotionData.feeDiscounts[18].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 20</div>
              <p>{{promotionData.feeDiscounts[19].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 21</div>
              <p>{{promotionData.feeDiscounts[20].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 22</div>
              <p>{{promotionData.feeDiscounts[21].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 23</div>
              <p>{{promotionData.feeDiscounts[22].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 24</div>
              <p>{{promotionData.feeDiscounts[23].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 25</div>
              <p>{{promotionData.feeDiscounts[24].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 26</div>
              <p>{{promotionData.feeDiscounts[25].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 27</div>
              <p>{{promotionData.feeDiscounts[26].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 28</div>
              <p>{{promotionData.feeDiscounts[27].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 29</div>
              <p>{{promotionData.feeDiscounts[28].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 30</div>
              <p>{{promotionData.feeDiscounts[29].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 31</div>
              <p>{{promotionData.feeDiscounts[30].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 32</div>
              <p>{{promotionData.feeDiscounts[31].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 33</div>
              <p>{{promotionData.feeDiscounts[32].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 34</div>
              <p>{{promotionData.feeDiscounts[33].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 35</div>
              <p>{{promotionData.feeDiscounts[34].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>
            <div class="col-6 col-sm-4 col-lg-2">
              <div class="generalTitleItemModal">Cuota 36</div>
              <p>{{promotionData.feeDiscounts[35].value || 0}}<template v-if="extraPromoData.discountTypeName == 'Absoluto'">€</template><template v-else-if="extraPromoData.discountTypeName == 'Porcentaje'">%</template></p>
            </div>

          </div>
        </template>
        <template v-if="promotionData.criteria.name !== '' && promotionData.criteria.condition !== ''">
          <div class="mb-3">
            <div class="generalSubtitle">Criterio</div>
          </div>
          <div class="row">
            <div class="col-6 col-sm-3 col-lg-3">
              <div class="generalTitleItemModal">Nombre</div>
              <p>{{promotionData.criteria.name || "-"}}</p>
            </div>
            <div class="col-6 col-sm-9 col-lg-9">
              <div class="generalTitleItemModal">Condición</div>
              <p>{{promotionCriteriaCondition || "-"}}</p>
            </div>
          </div>  
        </template>
      </div>
    </div>
    <div class="row mt-3 mx-1">
      <div class="col-12">
        <button class="btn btn-outline-secondary float-left generalSecondaryButton" @click="goBack()">Atrás</button>
        <router-link class="btn btn-outline-secondary float-left generalSecondaryButton ml-3"
          :to="{ name: 'newContractStep1' }" @click="removeStorage()">Cancelar</router-link>
        <button class="btn btn-primary float-right generalPrimaryButton btn-loading"
          @click="submit()" :disabled="loading">
          <span v-if="!loading">CREAR PROMOCIÓN</span>
          <img v-else src="../../../../../assets/loader.svg" height="20" alt="">  
        </button>

      </div>
    </div>
  </div>
  <ModalFinal :id="'finalModal'" :modalTitle="'Paso final'" :class="'modal'" :showFooter="false" />
  <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
    :message="errorMessage" :code="errorCode" />
  <ModalProducts :id="'productsModal'" :modalTitle="'Listado EAN promoción'" :class="'modal-lg'" :showFooter="false" :products="promotionData.products"/>
</template>
<script>
import axios from 'axios';
import ModalFinal from '../SuccessModal/FinalModal.vue';
import ModalError from '../../../Shared/ModalError.vue';
import ModalProducts from "../ProductsPromotion/productsModal.vue";
import { Modal as ModalBootstrap } from "bootstrap";
export default {
  name: 'ResumeContract',
  data() {
    return {
      loading: false,
      promotionData: this.$store.state.newPromotionData,
      extraPromoData: this.$store.state.recoveryData,
      bodyToSend: this.$store.state.newPromotionData,
      errorMessage: '',
      errorCode: '',
      productCalculate: [],
      calculated: false,
      promotionCriteriaCondition: ''
    };
  },
  created() {
    if(this.promotionData.criteria.parameters){
        let promotionCriteriaConditionTemp = this.promotionData.criteria.condition;
        for (const [key, value] of Object.entries(this.promotionData.criteria.parameters)) {
          promotionCriteriaConditionTemp = promotionCriteriaConditionTemp.replace(key, value)
        }
        this.promotionCriteriaCondition = promotionCriteriaConditionTemp;
      }
  },
  components: {
    ModalFinal,
    ModalError,
    ModalProducts
  },
  methods: {
    viewDetail(){
      var myModal = new ModalBootstrap(document.getElementById('productsModal'))
      myModal.show()
    },
    submit() {
      this.loading = true;
      let bodyToSend = this.$store.state.newPromotionData;
      bodyToSend.start_date = this.$dateFrontToBack(bodyToSend.start_date);
      bodyToSend.start_actived_date = bodyToSend.start_date;
      bodyToSend.end_date = this.$dateFrontToBack(bodyToSend.end_date);
      bodyToSend.end_actived_date = bodyToSend.end_date;
      for (let i = 0; i < bodyToSend.feeDiscounts.length; i++) {
        const element = bodyToSend.feeDiscounts[i];
        if (element.discountTypeName == 'Porcentaje') {
          element.discountType =  "PERCENTAGE";
        }else if(element.discountTypeName == 'Absoluto'){
          element.discountType =  "NUMBER";
        }
      }
      console.log('========== DEBUGGING PROMOTION CREATION ==========');
      console.log('Body to send - applyToRentServ:', bodyToSend.applyToRentServ);
      console.log('Complete bodyToSend:', bodyToSend);
      console.log('JSON stringified:', JSON.stringify(bodyToSend, null, 2));
      // eslint-disable-next-line no-debugger
      debugger; // Descomenta esta línea si necesitas pausar la ejecución
      console.log('========== END DEBUGGING ==========');
      let urlOrder = '/promotions/promotion';
      axios.post(urlOrder, bodyToSend)
        .then((response) => {
          console.log(response);
          this.removeStorage();
          var myModal = new ModalBootstrap(document.getElementById('finalModal'))
          myModal.show();
          this.loading = false;
        })
        .catch((error) => {
          this.errorCode = error.response.data.code
          this.errorMessage = error.response.data.message
          var myModal = new ModalBootstrap(document.getElementById('modalError'))
          myModal.show();
          this.loading = false;
        });
    },
    goBack() {
      this.$router.push({ name: 'newPromotionStep1' })
    },
    removeStorage() {
      this.$store.commit('RESET_STATE_PROMOTIONS');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../../../scss/variables.scss';
.typeNumber::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.typeNumber {
  appearance: textfield;
}

.textLink {
  color: $primary;
  cursor: pointer;

  &:hover {
    color: $primary-hover;
  }
}
</style>